document.addEventListener("DOMContentLoaded", () => {
  console.log('Script Loaded');

  // Future implementation: when user clicks on item in cart, preset it

  /* Step 1: Size */
  let MAX_FOCAL = 0;
  let MAX_ACCENT = 0;


  let focal_counter = document.querySelector(".focal-flowers-count");
  const focal_items = document.querySelectorAll(".focal-flower-item");

  let accent_counter = document.querySelector(".accent-flowers-count");
  const accent_items = document.querySelectorAll(".accent-flower-item");

  let selected_size = document.querySelector(".selected-size");

  document.querySelectorAll('.bouquet-size-option-button')
    .forEach(button => {
      button.addEventListener('click', () => {

        const selectedSize = button.dataset.size;

        const matchedVariant = bouquetProduct.variants.find(
          variant => variant.title === selectedSize
        );

        if (!matchedVariant) return;

        MAX_FOCAL = matchedVariant.focal;
        MAX_ACCENT = matchedVariant.accent;

        document.querySelector('.variant-id-input').value = matchedVariant.id;

        document.querySelectorAll(".bouquet-size-option-button")
          .forEach(btn => btn.classList.remove("active"));

        button.classList.add("active");

        focal_counter.textContent = `0/${MAX_FOCAL}`;
        accent_counter.textContent = `0/${MAX_ACCENT}`;

        focal_items.forEach(item => {
          item.querySelector(".focal-qty").textContent = "0";
          item.classList.remove("active");
        });

        accent_items.forEach(item => {
          item.querySelector(".accent-qty").textContent = "0";
          item.classList.remove("active");
        });

        selected_focals = {};
        selected_accents = {};

        renderBouquetSummary('focal');
        renderBouquetSummary('accent');

        document.querySelector('input[name="properties[Bouquet Size]"]').value = selectedSize;

        selected_size.textContent = selectedSize;
      });
  });

  // Update total for flowers selected
  function updateTotal(flower_type, flower_items, flower_qty) {
    let total = 0;

    flower_items.forEach(item => {
      const qty = parseInt(item.querySelector(flower_qty).textContent);
      total += qty;
    });

    if (flower_type == 'focal') {
      focal_counter.textContent = `${total}/${MAX_FOCAL}`;
    } else {
      accent_counter.textContent = `${total}/${MAX_ACCENT}`
    }
  }

  // summary bouquet update flowers
  function renderBouquetSummary(selected_flower_type) {
    let summaryList;
    let selected_flowers;

    if (selected_flower_type == 'focal') {
      summaryList = document.querySelector(".focal-summary ul");
      selected_flowers = selected_focals;
    } else {
      summaryList = document.querySelector(".accent-summary ul");
      selected_flowers = selected_accents;
    }

    if (!summaryList) return;
  
    summaryList.innerHTML = '';

    Object.keys(selected_flowers).forEach(name => {
      const quantity = selected_flowers[name];
      console.log('fetching summary of flower to count ')

      if (quantity > 0) {
        const li = document.createElement('li');
        li.textContent = `${name}: ${quantity}`;
        summaryList.appendChild(li);
      }
    });

    if (selected_flower_type == 'focal') {
      const focalString = Object.entries(selected_focals)
        .filter(([name, qty]) => qty > 0)
        .map(([name, qty]) => `${name} (${qty})`)
        .join(', ');
      
    const focalInput = document.querySelector('input[name="properties[Focal Flowers]"]');
    if (focalInput) focalInput.value = focalString;
    } else {
      const accentString = Object.entries(selected_accents)
        .filter(([name, qty]) => qty > 0)
        .map(([name, qty]) => `${name} (${qty})`)
        .join(', ');

      const accentInput = document.querySelector('input[name="properties[Accent Flowers]"]');
      if (accentInput) accentInput.value = accentString;
    }
  }

  let selected_focals = {}

  /* Step 2: Focal Flower */
  focal_items.forEach(item => {
    item.addEventListener("click", (event) => {

      // ignore minus clicks
      if (event.target.closest(".remove-focal-flower")) return;

      const focal_qty = item.querySelector(".focal-qty");
      let focal_cnt = parseInt(focal_qty.textContent);

      const currentFocalTotal = parseInt(focal_counter.textContent.split("/")[0]);
      if (currentFocalTotal >= MAX_FOCAL) return;

      focal_cnt++;
      focal_qty.textContent = focal_cnt;

      item.classList.add("active");

      updateTotal('focal', focal_items, ".focal-qty");

      // summary bouquet 
      const focal_name = item.getAttribute('name');
      selected_focals[focal_name] = focal_cnt;
      renderBouquetSummary('focal');
    });
  });


  // Remove focal flowers
  document.querySelectorAll('.remove-focal-flower').forEach(btn => {
    btn.addEventListener('click', (event) => {

      event.stopPropagation();

      const flower_item = btn.closest('.focal-flower-item');
      const qty = flower_item.querySelector('.focal-qty');

      let currentQty = parseInt(qty.textContent);

      if (currentQty > 0) {
        currentQty--;
        qty.textContent = currentQty;
      }

      if (currentQty == 0) {
        flower_item.classList.remove("active");
      }

      updateTotal('focal', focal_items, ".focal-qty");

      const focal_name = flower_item.getAttribute('name');
      selected_focals[focal_name] = currentQty;
      renderBouquetSummary('focal');
    });
  });

  let selected_accents = {}

  /* Step 3: Accent flowers */
  accent_items.forEach(item => {
   item.addEventListener("click", (event) => {
      console.log('Clicked on accent flower')
      // ignore minus clicks
      if (event.target.closest(".remove-accent-flower")) return;

      const accent_qty = item.querySelector(".accent-qty");
      let accent_cnt = parseInt(accent_qty.textContent);

      const currentAccentTotal = parseInt(accent_counter.textContent.split("/")[0]);
      if (currentAccentTotal >= MAX_ACCENT) return;

      accent_cnt++;
      accent_qty.textContent = accent_cnt;

      item.classList.add("active");

      updateTotal('accent', accent_items, ".accent-qty");

      // summary bouquet 
      const accent_name = item.getAttribute('name');
      selected_accents[accent_name] = accent_cnt;
      renderBouquetSummary('accent');
    });
  });

  // Remove accent flowers
  document.querySelectorAll('.remove-accent-flower').forEach(btn => {
    btn.addEventListener('click', (event) => {

      event.stopPropagation();

      const flower_item = btn.closest('.accent-flower-item');
      const qty = flower_item.querySelector('.accent-qty');

      let currentQty = parseInt(qty.textContent);

      if (currentQty > 0) {
        currentQty--;
        qty.textContent = currentQty;
      }

      if (currentQty == 0) {
        flower_item.classList.remove("active");
      }

      updateTotal('accent', accent_items, ".accent-qty");

      // summary bouquet 
      const accent_name = flower_item.getAttribute('name');
      selected_accents[accent_name] = currentQty;
      renderBouquetSummary('accent');
    });
  });

  /* Step 4 */
  const recipientInput = document.getElementById("recipients-name");
  const recipientNameCounter = document.querySelector(".recipient-name-counter");

  const personalNoteInput = document.querySelector("#personal-note");
  const personalNoteCounter = document.querySelector(".personal-note-counter");

  recipientInput.addEventListener("input", (event) => {
    if (recipientInput.value.length > 20) {
      recipientInput.value = recipientInput.value.slice(0, 20);
    };
    
    recipientNameCounter.textContent = `${recipientInput.value.length}/20`;

    let recipient = document.querySelector('.recipient-name-summary');
    recipient.textContent = recipientInput.value;

    const hiddenRecipient = document.querySelector('input[name="properties[Recipient]"]');
    if (hiddenRecipient) hiddenRecipient.value = recipientInput.value;
  });

  personalNoteInput.addEventListener("input", (event) => {
    if (personalNoteInput.value.length > 255) {
      personalNoteInput.value = personalNoteInput.value.slice(0, 255);
    };

    personalNoteCounter.textContent = `${personalNoteInput.value.length}/255`;

    let note = document.querySelector('.note-summary');
    note.textContent = personalNoteInput.value;

    const hiddenNote = document.querySelector('input[name="properties[Note]"]');
    if (hiddenNote) hiddenNote.value = personalNoteInput.value;
  });

  // Location
  document.addEventListener("click", (event) => {
    const location = event.target.closest(".location-options");
    if (!location) return;

    let selected_location = location.value;
    let location_summary = document.querySelector(".location-summary");
    if (location_summary) location_summary.textContent = selected_location;

    const hiddenLocation = document.querySelector('input[name="properties[Location]"]');
    if (hiddenLocation) hiddenLocation.value = location_summary.textContent;
  });

  const form = document.querySelector('form[action="/cart/add"]');
  const locationSelect = document.querySelector('.location-options');
  const addToCartBtn = document.querySelector('#add-to-cart-button');

  form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (!recipientInput.value || recipientInput.value === "") {
          alert("Please add recipient!");
          recipientInput.style.border = "2px solid red";
          return;
      }

      if (!locationSelect.value || locationSelect.value === "") {
          alert("Please select a pickup location!");      
          locationSelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
          locationSelect.style.border = "2px solid red";
          return; 
      }

      const photoSenderEmail = document.getElementById('photo-sender-email').value;
      const photoQty = parseInt(photoQuantity.value) || 0;

      if (photoQty > 0 && (!photoSenderEmail || photoSenderEmail === "")) {
          alert("Please enter the email address you will use to send your photos!");
          document.getElementById('photo-sender-email').focus();
          document.getElementById('photo-sender-email').style.border = "2px solid red";
          return;
      }

      const itemsArray = [{
          id: document.querySelector('.variant-id-input').value,
          quantity: 1,
          properties: {
              'Bouquet Size': document.querySelector('.input-size').value,
              'Focal Flowers': document.querySelector('.input-focal').value,
              'Accent Flowers': document.querySelector('.input-accent').value,
              'Recipient': recipientInput.value,
              'Note': personalNoteInput.value,
              'Location': locationSelect.value,
              'Photo Sender Email': photoQty > 0 ? photoSenderEmail : "N/A"
          }
      }];

      // if (photoQty > 0) {
      //     itemsArray.push({
      //         id: document.getElementById('photo-variant-id').value,
      //         quantity: photoQty,
      //         properties: { 'For Bouquet': `Order for ${recipientInput.value}` }
      //     });
      // }

      // 3. Simple Add and Update
      fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsArray })
      })
      .then(response => {
          if (!response.ok) throw new Error("Error adding items");

          // Update attribute so the drawer knows the latest choice
          return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                  attributes: {
                      order_type: locationSelect.value === "Delivery (Shipped)" ? "delivery" : "pickup"
                  }
              })
          });
      })
      .then(() => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
            cartDrawer.classList.add('active'); 
            cartDrawer.open(); 
        } else {
            window.location.href = '/cart';
        }
      })
      .catch(err => {
          console.error(err);
          alert("Error adding to cart. Please try again.");
      });
  });

  // Clean up the red border 
  recipientInput.addEventListener('change', () => {
    if (recipientInput.value !== "") {
      recipientInput.style.border = "1px solid rgb(111, 111, 111)";
    }
  });

  locationSelect.addEventListener('change', () => {
    if (locationSelect.value !== "") {
        locationSelect.style.border = "1px solid rgb(111, 111, 111)";
    }
  });

  const decrementPhotoQuantity = document.getElementById('decrement');
  const incrementPhotoQuantity = document.getElementById('increment');
  const photoQuantity = document.getElementById('photo-quantity');
  const emailWrapper = document.querySelector('.email-wrapper');
  const displayQuantity = document.getElementById('display-quantity');
  const photoSummary = document.querySelector('.photo-summary');

  const updateUI = (newValue) => {
    photoQuantity.value = newValue;

    if (displayQuantity) {
      displayQuantity.textContent = newValue;
    }

    if (photoSummary) {
      photoSummary.textContent = newValue;
    }
    
    if (newValue > 0) {
      emailWrapper.classList.remove('hidden');
    } else {
      emailWrapper.classList.add('hidden');
    }

    const photoSenderEmailInput = document.getElementById('photo-sender-email');

    photoSenderEmailInput.addEventListener('input', () => {
        if (photoSenderEmailInput.value !== "") {
            photoSenderEmailInput.style.border = "1px solid rgb(111, 111, 111)";
        }
    });
  };

  decrementPhotoQuantity.addEventListener('click', (event) => {
    let currentVal = parseInt(photoQuantity.value) || 0;

    if (currentVal > 0) {
      updateUI(currentVal - 1);
    }
  });

  incrementPhotoQuantity.addEventListener('click', (event) => {
    let currentVal = parseInt(photoQuantity.value) || 0;
    updateUI(currentVal + 1);
  });

  photoQuantity.addEventListener('input', () => {
    let currentVal = parseInt(photoQuantity.value) || 0;
    updateUI(currentVal);
  });
});

